import { takeLatest, put } from "redux-saga/effects";

import configRepository, { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_CREATE_OFFICE_SERVER,
  TriggerCreateOfficeServer,

  RESET_CREATE_OFFICE_SERVER
} from "./types";

import {
  createOfficeServerPending,
  createOfficeServerSuccess,
  createOfficeServerError
} from "./actions";
import { createCancellableSaga } from "../../../../../store/CancellableSaga";


function* handleTriggerCreateOfficeServer(action: TriggerCreateOfficeServer) {
  const { payload } = action;
  const { officeServer } = payload;

  yield put(createOfficeServerPending());

  let response: OfficeServerDetails;

  try {
    response = yield configRepository.createOfficeServer(officeServer);
  } catch (error) {
    yield put(createOfficeServerError(error));
    return;
  }

  yield put(createOfficeServerSuccess(response));
}


export function* watchCreateOfficeServerSaga() {
  yield takeLatest(TRIGGER_CREATE_OFFICE_SERVER, handleTriggerCreateOfficeServer);
}


export const createOfficeServerSaga = createCancellableSaga(
  watchCreateOfficeServerSaga, RESET_CREATE_OFFICE_SERVER
);